:host {
  display: block;
  font-family: var(--ls-font-family);
}

ls-status-item{
  margin: 1rem 0;
}

ls-status-item:first-of-type{
  margin-top: 0;
}

ls-status-item:last-of-type{
  margin-bottom: 0;
}
